import { css } from 'styled-components';

export const breakpoints = {
    desktop: 1440,
    laptop: 1279,
    tablet: 1000,
    phone: 700
}

export const isClient = () => {
    if (typeof window !== "undefined") {
        return true
    }

    return false;
}

const setMedia = size => (...args) => css`
    @media (max-width: ${size}px) {
        ${css(...args)}
    }
`;

const getMedia = (breakpoint) => () => {
    if (typeof navigator !== "undefined" && window && window.innerWidth <= breakpoints[breakpoint]) {
        return true
    }

    return false;
}

export const media = {
    desktop: setMedia(breakpoints.desktop),
    laptop: setMedia(breakpoints.laptop),
    tablet: setMedia(breakpoints.tablet),
    phone: setMedia(breakpoints.phone)
};

export const width = {
    desktop: getMedia('desktop'),
    laptop: getMedia('laptop'),
    tablet: getMedia('tablet'),
    phone: getMedia('phone')
}



// WEBPACK FOOTER //
// ./src/styles/utils.js